export enum LumiaColor {
  MelancholischerSchiffskapitaen = 'melancholischer-schiffskapitaen',
  AyahuascaNachher = 'ayahuasca-nachher',
  Vigoletto = 'vigoletto',
  BlueSpanishEyes = 'blue-spanish-eyes',
  AyahuascaVorher = 'ayahuasca-vorher',
  RasenmaeherRueckstaende = 'rasenmaeher-rueckstaende',
  AfterRooftopParty = 'after-rooftop-party',
  NichtWeiss = 'nicht-weiss',
  TouristinnenRot = 'touristinnen-rot',
}
